import useCheckRole from "Hooks/APICheckRole";
import React, { useState } from "react";
import { Card, Menu } from "semantic-ui-react";
import PermissionView from "./PermissionView";
import RoleView from "./RoleView";

const SecurityView = () => {
  const { hasRole, roles } = useCheckRole();
  const [activeView, setActiveView] = useState("permissions");
  const isPermission = hasRole(roles.security.permission.roles.view);
  const isRole = hasRole(roles.security.role.roles.view);
  return (
    <div>
      <Menu stackable fluid pointing>
        <Menu.Item header>Security</Menu.Item>
        {isPermission && (
          <Menu.Item
            link
            active={activeView === "permissions"}
            onClick={() => setActiveView("permissions")}
          >
            Permissions
          </Menu.Item>
        )}
        {isRole && (
          <Menu.Item
            link
            active={activeView === "roles"}
            onClick={() => setActiveView("roles")}
          >
            Roles
          </Menu.Item>
        )}
      </Menu>

      <Card fluid>
        {activeView === "permissions" && isPermission && <PermissionView />}
        {activeView === "roles" && isRole && <RoleView />}
      </Card>
    </div>
  );
};

export default SecurityView;
